import React, { Fragment } from 'react';
import styled from 'styled-components';
import { formatTextWithNumberValue } from './utils';
import { pluralize } from '../../../utils/formatText';
import { theme } from '../../../styles/theme';

interface IProps {
  compareTableSummary?: string;
  subjectName?: string;
  tableSize?: number;
  totalCount?: number;
  isPartialResult?: boolean;
}

const StyledSummary = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
  > span {
    font-weight: 600;
`;

const INSPECT_TABLE_SUBJECT_NAME = 'Event';
/**
 * take caption str like: xxxxx Users in common, xxx is number without comma inside
 * returns: x,xxx Users in common, x,xxx is bold
 */
export default ({
  subjectName,
  tableSize,
  totalCount,
  compareTableSummary,
  isPartialResult,
}: IProps) => {
  const getSubstringsWithNumberFormatted = (str: string): React.ReactNode => {
    const substrs = str.split(' ').map((substr) => substr.trim());
    return substrs.length > 0 ? (
      substrs.map((substr, index) => {
        const isNumber = !isNaN(Number(substr));
        const suffix = index !== substrs.length - 1 ? ' ' : '';
        return isNumber ? (
          <span key={`str-${index}`}>
            {formatTextWithNumberValue(substr) + suffix}
          </span>
        ) : (
          <Fragment key={`str-${index}`}>{substr + suffix}</Fragment>
        );
      })
    ) : (
      <></>
    );
  };

  // Special case, Compare table using summary.text + summary.count to display summary
  if (compareTableSummary) {
    return (
      <StyledSummary>
        {getSubstringsWithNumberFormatted(compareTableSummary)}
      </StyledSummary>
    );
  }

  // special case: hack: Kobol cannot return summary.totalCount if
  // the sampling rate is less than 100%, therefore display it as special case
  if (isPartialResult && tableSize && subjectName) {
    return (
      <StyledSummary>
        {getSubstringsWithNumberFormatted(
          `${tableSize} ${pluralize(subjectName, tableSize)} in Sample`,
        )}
      </StyledSummary>
    );
  }

  if (tableSize && totalCount) {
    const isDisplayingPartialResult = tableSize < totalCount;
    let displayText;
    const pluralizedName = pluralize(
      subjectName || INSPECT_TABLE_SUBJECT_NAME,
      totalCount,
    );
    if (isDisplayingPartialResult) {
      displayText = `Displaying ${tableSize} of ${totalCount} ${pluralizedName}`;
    } else {
      displayText = `${totalCount} ${pluralizedName} in Total`;
    }
    return (
      <StyledSummary>
        {getSubstringsWithNumberFormatted(displayText)}
      </StyledSummary>
    );
  }

  return <div></div>;
};
